/* eslint-disable */
// @ts-nocheck
import * as Types from '../../types.generated.js';

import { GetBlogCategoriesDataFragmentFragmentDoc, GetBlogCategoriesPaginationFragmentFragmentDoc } from './blog-post-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { customFetcher } from 'libs/data-access/src/lib/custom-fetcher/';
export type GetAllBlogCategoriesQueryVariables = Types.Exact<{
  input: Types.BlogCategoryWithPostsQueryArgs;
}>;


export type GetAllBlogCategoriesQuery = { __typename?: 'Query', getAllBlogCategoriesWithNestedPosts: { __typename?: 'CategoryWithPostsAttributesData', data?: Array<{ __typename?: 'CategoryWithPostsAttributes', name?: string | null, id?: string | null, posts?: Array<{ __typename?: 'FullPostAttributes', id?: string | null, title?: string | null }> | null, postsPagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null }> | null, pagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null } };


export const GetAllBlogCategoriesDocument = /*#__PURE__*/ `
    query GetAllBlogCategories($input: BlogCategoryWithPostsQueryArgs!) {
  getAllBlogCategoriesWithNestedPosts(input: $input) {
    ...GetBlogCategoriesDataFragment
    ...GetBlogCategoriesPaginationFragment
  }
}
    ${GetBlogCategoriesDataFragmentFragmentDoc}
${GetBlogCategoriesPaginationFragmentFragmentDoc}`;
export const useGetAllBlogCategoriesQuery = <
      TData = GetAllBlogCategoriesQuery,
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string}
    >(
      variables: GetAllBlogCategoriesQueryVariables,
      options?: UseQueryOptions<GetAllBlogCategoriesQuery, TError, TData>
    ) =>
    useQuery<GetAllBlogCategoriesQuery, TError, TData>(
      ['GetAllBlogCategories', variables],
      customFetcher<GetAllBlogCategoriesQuery, GetAllBlogCategoriesQueryVariables>(GetAllBlogCategoriesDocument, variables),
      options
    );

useGetAllBlogCategoriesQuery.getKey = (variables: GetAllBlogCategoriesQueryVariables) => ['GetAllBlogCategories', variables];
;

export const useInfiniteGetAllBlogCategoriesQuery = <
      TData = GetAllBlogCategoriesQuery,
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string}
    >(
      variables: GetAllBlogCategoriesQueryVariables,
      options?: UseInfiniteQueryOptions<GetAllBlogCategoriesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAllBlogCategoriesQuery, TError, TData>(
      ['GetAllBlogCategories.infinite', variables],
      (metaData) => customFetcher<GetAllBlogCategoriesQuery, GetAllBlogCategoriesQueryVariables>(GetAllBlogCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetAllBlogCategoriesQuery.getKey = (variables: GetAllBlogCategoriesQueryVariables) => ['GetAllBlogCategories.infinite', variables];
;

useGetAllBlogCategoriesQuery.fetcher = (variables: GetAllBlogCategoriesQueryVariables, options?: RequestInit['headers']) => customFetcher<GetAllBlogCategoriesQuery, GetAllBlogCategoriesQueryVariables>(GetAllBlogCategoriesDocument, variables, options);